import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { Compact, Fullscreen } from './styles';

interface FallbackProps {
  text: string;
  variant?: 'fullscreen' | 'compact';
}

function Fallback({ text, variant = 'fullscreen' }: FallbackProps) {
  const Container = variant === 'compact' ? Compact : Fullscreen;

  return (
    <Container>
      <CircularProgress
        size={variant === 'compact' ? 22 : 40}
        color="inherit"
      />
      <Typography
        variant={variant === 'compact' ? 'body2' : 'h4'}
        sx={{
          marginLeft: variant === 'compact' ? 0 : 2,
          color: (theme) => theme.palette.white['06'],
        }}
      >
        {text}
      </Typography>
    </Container>
  );
}

export default Fallback;
